import { init } from '@rematch/core';
import { models, RootModel } from './state';

export const store = init<RootModel>({ models });
export type Store = typeof store;
